/**
 * AgentInteractionLog -- Local logging of agent interactions.
 * Stores interactions in localStorage for effectiveness tracking.
 * Future: migrate to nexo_catalogs.n8n_instruction_runs.
 *
 * @module application/AgentInteractionLog
 */

const STORAGE_KEY = 'nx_agent_interactions';
const MAX_ENTRIES = 200;

function loadEntries() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch {
    return [];
  }
}

function saveEntries(entries) {
  const trimmed = entries.slice(-MAX_ENTRIES);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
}

export const AgentInteractionLog = {
  log({ userMsg, agentResponse, action = 'chat', source = 'n8n' }) {
    const entries = loadEntries();
    entries.push({
      id: crypto.randomUUID(),
      timestamp: new Date().toISOString(),
      userMsg,
      agentResponse: typeof agentResponse === 'string'
        ? agentResponse
        : JSON.stringify(agentResponse),
      action,
      source,
      wasHelpful: null
    });
    saveEntries(entries);
    return entries[entries.length - 1].id;
  },

  setFeedback(entryId, wasHelpful) {
    const entries = loadEntries();
    const entry = entries.find(e => e.id === entryId);
    if (entry) {
      entry.wasHelpful = wasHelpful;
      saveEntries(entries);
    }
  },

  getStats() {
    const entries = loadEntries();
    const withFeedback = entries.filter(e => e.wasHelpful !== null);
    const helpful = withFeedback.filter(e => e.wasHelpful === true).length;
    const actions = {};
    for (const e of entries) {
      actions[e.action] = (actions[e.action] || 0) + 1;
    }
    return {
      total: entries.length,
      withFeedback: withFeedback.length,
      helpful,
      unhelpful: withFeedback.length - helpful,
      helpfulRate: withFeedback.length > 0
        ? Math.round((helpful / withFeedback.length) * 100)
        : null,
      byAction: actions
    };
  },

  getRecent(limit = 20) {
    return loadEntries().slice(-limit).reverse();
  },

  clear() {
    localStorage.removeItem(STORAGE_KEY);
  }
};
